import React, {FunctionComponent, useEffect, useLayoutEffect, useState,} from "react";
import {makeStyles} from "tss-react/mui";
import {Badge, Button, Grid, MenuList, Select, Theme, Tooltip, Typography,} from "@mui/material";
import {DRAWER_WIDTH} from "../../../../Components/Sidebar/Constants";
import {CHANGE_STATION_START, FETCHING_DATA_START,} from "../../../../Redux/Disposition/Constants";
import ReplayIcon from "@mui/icons-material/Replay";
import ReorderIcon from "@mui/icons-material/Reorder";
import SearchIcon from "@mui/icons-material/Search";
import LegendModal from "@/Domains/DispositionManagement/Components/Modals/LegendModal";
import SearchModal from "@/Domains/DispositionManagement/Components/Modals/SearchModal";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import Grow from "@mui/material/Grow";
import {useAppDispatch, useAppSelector} from "../../../../Redux/Redux";
import {RootStateOrAny, useDispatch, useSelector} from "react-redux";
import {selectViewerEnabledStations, selectViewerPrintname, ViewerState,} from "../../../../Redux/Auth/AuthReducer";
import {selectMandant} from "../../../../Redux/App/AppReducer";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import {updateAutoDispoStatus} from "../../../../Redux/Disposition/DispositionActions";
import DisableAutoDispoMutation from "../../Mutations/DisableAutoDispoMutation";
import {useTranslation} from "../../../../Utils/CustomHooks/useTranslation";

interface DispositionHeaderMainProps {
    contentWidth: number | undefined;
    setHeight: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    header: {
        // @ts-ignore
        backgroundColor: theme.palette.background.darker,
        minHeight: "82px",
        position: "fixed",
        top: 0,
        right: 6,
        zIndex: 415,
        borderTop: "4px solid transparent",
        width: "calc(10% - " + (DRAWER_WIDTH + 12) + "px)",
    },

    formControl: {
        minWidth: 120,
    },

    selectEmpty: {},

    select: {
        paddingTop: 0,
        paddingBottom: 0,
    },
}));

const DispositionHeaderMain: FunctionComponent<DispositionHeaderMainProps> = ({
                                                                                  contentWidth,
                                                                                  setHeight,
                                                                              }): JSX.Element => {
    const {classes} = useStyles();
    const printname = useSelector((state) =>
        selectViewerPrintname(state as ViewerState),
    );
    const enabledStations = useSelector((state) =>
        selectViewerEnabledStations(state as ViewerState),
    );
    const mandant = useSelector((state) =>
        selectMandant(state as RootStateOrAny),
    );
    const {t} = useTranslation();

    const {selectedStation, dispositionStartdate, dispositionEnddate} =
        useAppSelector((state) => state.disposition);
    const [legendIsOpen, setLegendIsOpen] = useState(false);
    const [searchIsOpen, setSearchIsOpen] = useState(false);
    const appDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const [autoDispoOff, setAutoDispoOff] = useState(false);
    // Task 1130780: AVIS Check AutoDispo Status
    if (mandant?.abasId == 70447) {
        useEffect(() => {
            const interval = setInterval(() => {
                dispatch(
                    updateAutoDispoStatus(
                        selectedStation,
                        (isDeactivated) => {
                            setAutoDispoOff(isDeactivated);
                        },
                    ),
                );
            }, 10000);
            return () => {
                clearInterval(interval);
            };
        }, [selectedStation]);
    }

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);

    useLayoutEffect(() => {
        setHeight(
            document.getElementById("disposition_header")?.clientHeight || 0,
        );
    });

    const handleLegendClose = () => {
        setLegendIsOpen(false);
    };

    const handleSearchClose = () => {
        setSearchIsOpen(false);
    };

    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        //if (prevOpen.current === true && open === false) {
        //    anchorRef.current!.focus();
        //}

        prevOpen.current = open;
    }, [open]);

    const handleClose = (event: React.MouseEvent<EventTarget>) => {
        //if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
        //    return;
        //}

        setOpen(false);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        }
    }

    const renderSelect = () => {
        return (
            <Select
                classes={{
                    select: classes.select,
                }}
                variant={"outlined"}
                style={{height: "calc(1.5em + .5rem)"}}
                native
                value={selectedStation || ""}
                onChange={(e) => {
                    appDispatch({
                        type: CHANGE_STATION_START,
                        payload: e.target.value,
                    });
                }}
                inputProps={{
                    name: "age",
                    id: "outlined-age-native-simple",
                }}
            >
                {enabledStations
                    .filter(
                        (station: any) => station.isChangeableInDispo == "J",
                    )
                    .map((station: { stationId: string; name: string }) => (
                        <option
                            key={station.stationId}
                            value={station.stationId}
                        >
                            {station.stationId} - {station.name}
                        </option>
                    ))}
            </Select>
        );
    };

    return (
        <>
            <header
                id={"disposition_header"}
                className={classes.header}
                style={{
                    width: contentWidth,
                }}
            >
                <Grid
                    container
                    spacing={0}
                    style={{
                        padding: "1rem",
                    }}
                >
                    <Grid item xs={8}>
                        <Typography component={"p"}>
                            <b>
                                {t("disposition.messages.greeting")} {printname}
                                ,
                            </b>
                        </Typography>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: "end"}}>
                        {mandant?.abasId == 70447 && (
                            <>
                                <Tooltip
                                    title={t(
                                        "disposition.controls.tooltip.deactivateAutoDispo",
                                    )}
                                >
                                    <Button
                                        variant={"outlined"}
                                        disabled={autoDispoOff}
                                        color="secondary"
                                        style={{
                                            backgroundColor: autoDispoOff
                                                ? "rgb(255, 210, 210)"
                                                : "lightgreen",
                                        }}
                                        size={"small"}
                                        onClick={() => {
                                            DisableAutoDispoMutation(
                                                {stationId: selectedStation},
                                                () => {
                                                    dispatch(
                                                        updateAutoDispoStatus(
                                                            selectedStation,
                                                            (
                                                                isDeactivated
                                                            ) => {
                                                                setAutoDispoOff(
                                                                    isDeactivated,
                                                                );
                                                            },
                                                        ),
                                                    );
                                                },
                                            );
                                        }}
                                    >
                                        <PlaylistRemoveIcon/>
                                    </Button>
                                </Tooltip>{" "}
                            </>
                        )}
                        <Tooltip
                            title={t("disposition.controls.tooltip.showLegend")}
                        >
                            <Button
                                variant={"outlined"}
                                color="secondary"
                                data-testid={"showLegend"}
                                size={"small"}
                                onClick={() => {
                                    setLegendIsOpen(true);
                                }}
                            >
                                <ReorderIcon/>
                            </Button>
                        </Tooltip>{" "}
                        <Tooltip
                            title={t(
                                "disposition.controls.tooltip.reloadDispo",
                            )}
                        >
                            <Button
                                variant={"outlined"}
                                color="secondary"
                                size={"small"}
                                onClick={() => {
                                    appDispatch({
                                        type: FETCHING_DATA_START,
                                        payload: {
                                            startdate: dispositionStartdate,
                                            enddate: dispositionEnddate,
                                            selectedStation: selectedStation,
                                        },
                                    });
                                }}
                            >
                                <ReplayIcon/>
                            </Button>
                        </Tooltip>{" "}
                        <Tooltip
                            title={t(
                                "disposition.controls.tooltip.searchDispo",
                            )}
                        >
                            <Button
                                variant={"outlined"}
                                color="secondary"
                                size={"small"}
                                data-testid={"searchDispo"}
                                onClick={() => {
                                    setSearchIsOpen(true);
                                }}
                            >
                                <SearchIcon/>
                            </Button>
                        </Tooltip>{" "}
                        {/*<Button
                            variant={"outlined"} color="secondary"
                            ref={anchorRef}
                            aria-controls={open ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                            onClick={handleToggle}
                        >
                            <Badge badgeContent={100} color="primary" variant="dot">
                                <NotificationsNoneOutlinedIcon/>
                            </Badge>

                        </Button>*/}
                        <Popper
                            open={open}
                            anchorEl={anchorRef.current}
                            role={undefined}
                            transition
                            disablePortal
                        >
                            {({TransitionProps, placement}) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{
                                        transformOrigin:
                                            placement === "bottom"
                                                ? "center top"
                                                : "center bottom",
                                    }}
                                >
                                    <Paper>
                                        <MenuList
                                            autoFocusItem={open}
                                            id="menu-list-grow"
                                            onKeyDown={handleListKeyDown}
                                        >
                                            <MenuItem onClick={handleClose}>
                                                {t("disposition.controls.checkApprovalNumbersKK")}
                                            </MenuItem>
                                            <MenuItem onClick={handleClose}>
                                                {t("disposition.controls.uneditReports")}
                                            </MenuItem>
                                            <MenuItem onClick={handleClose}>
                                                <Badge
                                                    variant={"dot"}
                                                    color="primary"
                                                >

                                                    {t("disporition.controls.uneditInternetReservations")}
                                                </Badge>
                                            </MenuItem>
                                            <MenuItem onClick={handleClose}>
                                                {t("disposition.controls.changedInternetReservations")}
                                            </MenuItem>
                                            <MenuItem onClick={handleClose}>
                                                {t("disposition.controls.Interrogate")}
                                            </MenuItem>
                                            <MenuItem onClick={handleClose}>
                                                {t("disposition.controls.Resubmissions")}
                                            </MenuItem>
                                            <MenuItem onClick={handleClose}>
                                                {t("dispositon.controls.canceledInternetReservations")}
                                            </MenuItem>
                                        </MenuList>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </Grid>
                </Grid>
            </header>
            {legendIsOpen && (
                <LegendModal
                    open={legendIsOpen}
                    handleClose={handleLegendClose}
                />
            )}
            {searchIsOpen && (
                <SearchModal
                    open={searchIsOpen}
                    handleClose={handleSearchClose}
                />
            )}
        </>
    );
};

export default DispositionHeaderMain;
